/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-shadow */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable operator-linebreak */
/* eslint-disable comma-dangle */
import React, { useState, useEffect } from 'react';
import {
  List,
  TextField,
  Button,
  Checkbox,
  Grid,
  Typography,
  FormControlLabel,
  InputAdornment,
  Autocomplete,
  Tooltip,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import api from 'services/api';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { useSelector } from 'react-redux';
import NumberFormat from 'react-number-format';
import { formatNumberPtbr } from 'utils/format-number-ptbr';
import { useDependencyInjection } from 'hooks/useDependencyInjection';
import { POND_STATUS_CYCLE } from 'utils/consts';
import { labelField } from 'utils';
import Error from 'components/Snack/Error';
import { withStyles } from '@mui/styles';
import HelpIcon from '@mui/icons-material/Help';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function HandleProductions(data) {
  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle
  );

  const [newHarvest, setNewHarvest] = useState({
    id: null,
    production: null,
    population: null,
    want_to_finish: false,
    pond: { description: null, status: null },
    quantity: null,
  });
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [openDeletePond, setOpenDeletePond] = useState(false);
  const [cycles, setCycles] = useState([]);
  const [options, setOptions] = useState([]);
  const [check, setCheck] = useState(false);
  const [iteracao, setIteracao] = useState(0);
  const [concluded, setConcluded] = useState(false);
  const [productionIsNull, setProductionIsNull] = useState(false);
  const [averageWeight, setAverageWeight] = useState(0);

  const { id } = useParams();

  const [openDialogNewHarvest, setOpenDialogNewHarvest] = React.useState(false);

  const { success, error } = useDependencyInjection();

  useEffect(() => {
    setIteracao(iteracao + 1);
    if (options.length === 0 && iteracao > 1) data.setPondsIsNull(true);
  }, [options]);

  useEffect(() => {
    if (options.length > 0) data.setPondsIsNull(false);
  }, [newHarvest]);

  useEffect(() => {
    async function load() {
      const cycles_ = await api.get(`/cycles/cycle-code/${selectedCycle?.id}`);
      setCycles(
        cycles_.data.filter(
          (cycle) => cycle.status === POND_STATUS_CYCLE.CULTIVANDO
        )
      );
      setConcluded(
        cycles_.data.length ===
          cycles_.data.filter((cycle) => cycle.status === 'Concluído').length
      );
    }
    load();
  }, [selectedCycle]);

  const handleClose = () => {
    setOpenDialogNewHarvest(false);
  };

  const handleSubmit = (event) => {
    if (productionIsNull) return false;
    addOption();
    data.att(!data.alter);
    handleClose();
  };

  useEffect(() => {
    setOptions(data.options);
    if (data.options?.length > 0) {
      data.att((prev) => !prev);
    }
  }, [data.options]);

  // Função que adiciona um objeto suprimento em entradas
  async function addOption() {
    const pivot = options;
    pivot.push(newHarvest);
    setNewHarvest({
      id: null,
      production: null,
      cycle_id: null,
      population: null,
      want_to_finish: false,
      pond: { description: null, status: null },
      quantity: null,
    });
    setOptions(pivot);
  }

  // Função que deleta o objeto suprimento escolhido
  async function deleteOption(i) {
    const newList = options;
    const obj = {
      cycle_id: options[i].cycle_id,
    };
    newList.splice(i, 1);
    setOptions(newList);
  }
  // Função que atualiza o objeto suprimento escolhido
  async function updateOption(i) {
    try {
      if (id) {
        const obj = {
          input: id,
          cycle: options[i].cycle_id,
          production: options[i].production,
          population: options[i].population,
          cycle_original: options[i].supply_original,
        };

        await api.put('/updateCycle', { ...obj }).then(() => {
          setCheck(false);
        });
      }
    } catch (err) {}
  }

  const deletePond = (cycle_id) => {
    if (id) {
      api
        .delete(`/harvests/${data.harvestId}/cycle/${cycle_id}`)
        .then((response) => {
          success();
        })
        .catch((e) => {
          error(e);
        });
    }
  };

  const handleCloseDeletePond = () => {
    setOpenDeletePond(false);
  };

  function handleDeletePond() {
    const currentOptions = [...options];
    const optionsToRemove = options.filter((o) =>
      selectedOptions.every((opt) => o.cycle_id !== opt.cycle_id)
    );

    optionsToRemove.forEach((o) => {
      const index = currentOptions.findIndex(
        (opt) => opt.cycle_id === o.cycle_id
      );
      currentOptions.splice(index, 1);
    });

    setOptions(currentOptions);
    data.callback(currentOptions);
    setOpenDeletePond(false);
  }

  const formatWeight = (weight) => {
    if (weight >= 1000) {
      return `${(weight / 1000).toFixed(2)}kg`;
    }
    return `${weight}g`;
  };

  async function handleFilterPondsOrigin(idSearch) {
    try {
      const getAverageWeight = await api.get(`/biomeasures/last/${idSearch}`);

      setAverageWeight(getAverageWeight.data.average_weight);
    } catch (err) {}
  }

  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  useEffect(() => {
    if (newHarvest.production) {
      setProductionIsNull(false);
    } else {
      setProductionIsNull(true);
    }
  }, [newHarvest]);

  useEffect(() => {
    if (newHarvest.id) {
      handleFilterPondsOrigin(newHarvest.id);
    }
  }, [newHarvest.id]);

  return (
    <List dense align="center" sx={{ pt: 0, pb: 0 }}>
      <Dialog
        open={openDialogNewHarvest}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={handleSubmit}>
          <DialogTitle id="form-dialog-title">Produção do viveiro</DialogTitle>
          <DialogContent
            sx={{
              '&.MuiDialogContent-root': {
                pt: 2,
              },
            }}
          >
            <DialogContentText />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  autoFocus
                  id="name"
                  disabled
                  value={newHarvest.pond.description}
                  label="Viveiro"
                  type="text"
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} md={id ? 6 : 4}>
                <TextField
                  fullWidth
                  autoFocus
                  id="averageWeight"
                  disabled
                  value={`${averageWeight}g`}
                  label="Peso médio do viveiro"
                  type="text"
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} md={id ? 6 : 4}>
                <TextField
                  fullWidth
                  autoFocus
                  id="averageWeight"
                  disabled
                  value={` ${newHarvest.population} `}
                  label="População do viveiro"
                  type="text"
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} md={id ? 6 : 4}>
                <TextField
                  fullWidth
                  autoFocus
                  id="averageWeight"
                  disabled
                  value={formatWeight(averageWeight * newHarvest.population)}
                  type="text"
                  variant="outlined"
                  label={
                    <div>
                      Estimativa de peso
                      <HtmlTooltip
                        title={
                          <>
                            Essa é uma estimativa do peso total do viveiro, com
                            base em seu peso médio e população.
                          </>
                        }
                        placement="right"
                        arrow
                      >
                        <HelpIcon color="primary" fontSize="inherit" />
                      </HtmlTooltip>
                    </div>
                  }
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <NumberFormat
                  fullWidth
                  autoFocus
                  variant="outlined"
                  inputProps={{ maxLength: 9 }}
                  id="quantity"
                  name="quantity"
                  value={newHarvest.quantity}
                  onValueChange={(values) => {
                    setNewHarvest({
                      ...newHarvest,
                      quantity: values.floatValue,
                    });
                  }}
                  label="Quantidade despescada"
                  thousandSeparator="."
                  decimalSeparator=","
                  customInput={TextField}
                  allowNegative={false}
                  error={newHarvest.quantity > newHarvest.population}
                  helperText={
                    newHarvest.quantity > newHarvest.population &&
                    'Retirada maior do que a população do viveiro'
                  }
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <NumberFormat
                  fullWidth
                  variant="outlined"
                  inputProps={{ maxLength: 9 }}
                  id="production"
                  name="production"
                  value={newHarvest.production}
                  onValueChange={(values) => {
                    setNewHarvest({
                      ...newHarvest,
                      production: values.floatValue,
                    });
                  }}
                  label="Produção"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">KG:</InputAdornment>
                    ),
                  }}
                  thousandSeparator="."
                  decimalSeparator=","
                  customInput={TextField}
                  allowNegative={false}
                  error={newHarvest.production <= 0}
                  helperText={
                    productionIsNull &&
                    'É necessário inserir uma quantidade maior que zero'
                  }
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <FormControlLabel
                  fullWidth
                  control={
                    <Checkbox
                      checked={newHarvest.want_to_finish}
                      onChange={(e) => {
                        if (newHarvest.want_to_finish === false) {
                          setNewHarvest({
                            ...newHarvest,
                            want_to_finish: true,
                          });
                        } else {
                          setNewHarvest({
                            ...newHarvest,
                            want_to_finish: false,
                          });
                        }
                      }}
                      name="TransferComplet"
                      color="primary"
                    />
                  }
                  label="Deseja concluir este viveiro ?"
                />
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions style={{ padding: '0rem 1.5rem 1.5rem 0rem' }}>
            <Button
              variant="outlined"
              onClick={handleClose}
              style={{
                border: '1px solid red',
                color: 'red',
              }}
            >
              Cancelar
            </Button>
            <Button
              style={{
                backgroundColor: '#0267C1',
                color: 'white',
              }}
              color="primary"
              onClick={() => handleSubmit()}
            >
              Adicionar
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Autocomplete
        disabled={data.disabled}
        id="combo-box-demo"
        noOptionsText={
          concluded ? (
            <Typography>
              Todos os Viveiros desse Ciclo estão Concluídos.
            </Typography>
          ) : (
            <Typography>Nenhum viveiro configurado para esse ciclo.</Typography>
          )
        }
        multiple
        disableCloseOnSelect
        value={options}
        options={cycles}
        getOptionLabel={(option) => {
          if (option.cycle) {
            return `${option.cycle.pond.description} - ${
              option.quantity
            }U- ${formatNumberPtbr(option.production)} kg`;
          }
          return `${option.pond.description} - ${
            option.quantity
          }U - ${formatNumberPtbr(option.production)} kg`;
        }}
        isOptionEqualToValue={(option, value) =>
          value && value.id === option.id
        }
        renderInput={(params) => (
          <TextField
            onBlur={data.validateThatPriceHasBeenFilled}
            {...params}
            label={labelField('Produção por viveiro')}
            variant="outlined"
            fullWidth
            error={data.error || data.pondsIsNull}
            helperText={
              data.helperText || (data.pondsIsNull && 'Campo Obrigatório')
            }
          />
        )}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
              color="primary"
            />
            {option.pond.description}
          </li>
        )}
        onChange={(event, selectedOptions, r) => {
          setSelectedOptions(selectedOptions);
          if (r === 'removeOption') {
            setOpenDeletePond(true);
          } else if (selectedOptions.length > 0) {
            const selected = selectedOptions[selectedOptions.length - 1];
            setNewHarvest({
              ...selected,
              cycle_id: selected.id,
              want_to_finish: false,
            });
            setOpenDialogNewHarvest(true);
          } else {
            setOptions([]);
            data.callback([]);
          }
        }}
      />

      <Dialog
        open={openDeletePond}
        onClose={handleCloseDeletePond}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Deseja realmente excluir esse insumo?
        </DialogTitle>
        <DialogActions style={{ padding: '1rem' }}>
          <Button
            variant="outlined"
            onClick={handleCloseDeletePond}
            style={{
              border: '1px solid red',
              color: 'red',
            }}
          >
            Não
          </Button>
          <Button
            onClick={handleDeletePond}
            style={{
              backgroundColor: '#0267C1',
              color: 'white',
            }}
          >
            Sim
          </Button>
        </DialogActions>
      </Dialog>
    </List>
  );
}
